module.exports = __webpack_public_path__ + "media/application/images/svgs/spotify-26646f93993466fa19e6f00245107e9c.svg";